import React from 'react';

const ToggleHighlightButtons = ({ title1, title2, btnCb, highlighted, disabled = false, type = 'button' }) => {
  const handleClick = (id) => {
    btnCb(id);
  };

  const buttons = [
    { id: 1, title: title1, active: highlighted, isCons: true },
    { id: 2, title: title2, active: !highlighted, isCons: false },
  ];

  return (
    <>
      {buttons.map(({ id, title, active, isCons }) => (
        <button
          key={id}
          disabled={active || disabled}
          onClick={() => handleClick(isCons)}
          type={type}
          className={`w-full truncate font-semibold py-2 px-4 rounded-full ${
            active ? 'bg-orange-500 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
          }`}>
          {title}
        </button>
      ))}
    </>
  );
};

export default ToggleHighlightButtons;
